// Core 10
import oliver from "./oliver.svg";
import amelia from "./amelia.svg";
import mateo from "./mateo.svg";
import chloe from "./chloe.svg";
import aaliyah from "./aaliyah.svg";
import madison from "./madison.svg";
import grace from "./grace.svg";
import logan from "./logan.svg";
import jackson from "./jackson.svg";
import arjun from "./arjun.svg";

// Hindi
import aditya from "./aditya.svg";
import shalini from "./shalini.svg";
import kabir from "./kabir.svg";
import meera from "./meera.svg";
import dinesh from "./dinesh.svg";
import riya from "./riya.svg";

// Telugu
import raghav from "./raghav.svg";
import savitri from "./savitri.svg";
import kiran from "./kiran.svg";
import sowmya from "./sowmya.svg";
import srinivas from "./srinivas.svg";
import ayesha from "./ayesha.svg";

// Spanish
import lucia from "./lucia.svg";
import carmen from "./carmen.svg";
import diego from "./diego.svg";
import valeria from "./valeria.svg";
import javier from "./javier.svg";
import sofia from "./sofia.svg";

// Chinese
import wei from "./wei.svg";
import meilin from "./meilin.svg";
import jun from "./jun.svg";
import lian from "./lian.svg";
import chen from "./chen.svg";
import xinyi from "./xinyi.svg";

// Arabic
import yasmeen from "./yasmeen.svg";
import nura from "./nura.svg";
import fahad from "./fahad.svg";
import omar from "./omar.svg";
import hassan from "./hassan.svg";
import layla from "./layla.svg";

export const CHARACTER_ICONS: Record<string, string> = {
  oliver,
  amelia,
  mateo,
  chloe,
  aaliyah,
  madison,
  grace,
  jackson,
  arjun,
  aditya,
  shalini,
  kabir,
  meera,
  dinesh,
  riya,
  raghav,
  savitri,
  kiran,
  sowmya,
  srinivas,
  ayesha,
  lucia,
  carmen,
  diego,
  valeria,
  javier,
  sofia,
  wei,
  meilin,
  jun,
  lian,
  chen,
  xinyi,
  logan,
  yasmeen,
  nura,
  fahad,
  omar,
  hassan,
  layla,
};
